<script>
import BaseMap from '@/components(new)/UI/Maps/BaseMap/BaseMap.vue'
import RegistrationMapManager from '@/components(new)/UI/Maps/core/registrationMapManager.js'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'

export default {
  components: {
    BaseTable,
    BaseMap
  },
  emits: ['carInfo', 'removeCar'],
  props: {
    validation: {
      default: ''
    },
    validationName: {
      default: ''
    },
    showInfoMessage: {
      default: true
    },
    onlyView: {
      default: false
    }
  },
  data () {
    return {
      mapManager: null,
      columns: [
        {
          key: 'cod_imovel',
          label: 'Código do CAR'
        },
        {
          key: 'uf',
          label: 'UF',
          width: '50px'
        },
        {
          key: 'municipio',
          label: 'Município'
        },
        {
          key: 'actions',
          label: 'Ação',
          width: '100px'
        }
      ],
      tableData: [],
      hasCarInfo: false
    }
  },
  mounted () {
    this.mapManager = new RegistrationMapManager(this.$refs.baseMapImovel.mapManager, this.carInfoCb, this.onlyView)

    if (!this.onlyView) {
      this.mapManager.map.on('layeradd', this.handleLayers)
      this.mapManager.map.on('click', this.mapClickCb)
      this.mapManager.map.on('draw:created', this.handleDrawCreated)
      this.mapManager.map.on('draw:deleted', this.handleDrawDeleted)
    }
  },
  methods: {
    carInfoCb (state) {
      this.hasCarInfo = state
      if (!state) {
        const prevList = [...this.listCar]
        this.tableData = []
        this.$emit('carInfo', { current: this.listCar, prev: prevList, layers: [] })
      }
    },
    handleLayers (e) {
      if (this.mapManager.layers?.length) {
        this.$emit('setLayers', this.mapManager.layers)
      }
    },
    async mapClickCb (e) {
      const carInfo = await this.mapManager.fetchCarInfo(e)
      if (!carInfo) return

      const hasCarInfo = this.tableData.find((item) => item.cod_imovel === carInfo.cod_imovel)
      if (hasCarInfo) return

      const prevList = [...this.listCar]

      this.tableData.push({ ...carInfo, actions: [{ key: 'remove', label: 'Remover', icon: 'trash' }] })
      this.$emit('carInfo', { current: this.listCar, prev: prevList, layers: this.mapManager.layers })
    },
    async addCARLayer (car) {
      const carInfo = await this.mapManager.addLayerByCAR(car)

      if (!carInfo) return

      const hasCarInfo = this.tableData.find((item) => item.cod_imovel === carInfo.cod_imovel)
      if (hasCarInfo) return

      const prevList = [...this.listCar]

      this.tableData.push({ ...carInfo, actions: [{ key: 'remove', label: 'Remover', icon: 'trash' }] })
      this.$emit('carInfo', { current: this.listCar, prev: prevList, layers: this.mapManager.layers })
    },
    handleDrawCreated (e) {
      this.mapManager.handleDrawCreated(e)
    },
    handleDrawDeleted (e) {
      this.mapManager.handleDrawDeleted(e)
      const prevList = [...this.listCar]
      this.tableData = []
      this.$emit('carInfo', { current: this.listCar, prev: prevList, layers: this.mapManager.layers })
    },
    removeCarFromTable (action) {
      const codImovel = action.rowData.cod_imovel
      this.removeCar(codImovel)
      this.$emit('removeCar', codImovel)
    },
    removeCar (carNumber) {
      const prevList = [...this.listCar]
      this.tableData = this.tableData.filter((item) => item.cod_imovel !== carNumber)
      this.mapManager.removeSelectedCarLayer(carNumber)
      this.$emit('carInfo', { current: this.listCar, prev: prevList, layers: this.mapManager.layers })
    },
    addProperty (geo) {
      this.mapManager.addPropertyLayers(geo)

      geo.numerosCar.forEach(car => {
        const geoJson = car.geoJson
        this.tableData.push({ ...geoJson[0].properties, features: geoJson, actions: [{ key: 'remove', label: 'Remover', icon: 'trash' }] })
      })
    }
  },
  computed: {
    listCar () {
      return this.tableData.map((item) => ({
        numero: item.cod_imovel,
        geoJson: item.features
      }))
    }
  },
  expose: {
    removeCar: this.removeCar,
    addProperty: this.addProperty
  }
}
</script>

<template>
  <validation-provider :rules="validation" v-slot="{ errors }" :name="validationName">
    <BaseMap :id="'sedap-map-imovel'" ref="baseMapImovel" :class="{'input erro' : errors.length}">
      <template #bottom v-if="!onlyView">
        <div class="sedap-registration-map__car-info" v-if="hasCarInfo">
          <div v-if="showInfoMessage" class="sedap-registration-map__message-box">
            <font-awesome-icon icon="info-circle" />
            <span>
              Selecione no mapa os números do CAR pertencentes ao seu imóvel.
            </span>
          </div>
          <BaseTable
            v-if="tableData.length"
            :columns="columns"
            :tableData="tableData"
            stripe
            @onAction="removeCarFromTable"
          />
        </div>
      </template>
    </BaseMap>
    <span class="help erro"> {{ errors[0] }}</span>
  </validation-provider>
</template>

<style lang="scss">
.sedap-registration-map__message-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-block: 0.8rem;
  border: 1px solid #0caf71;
  padding: 0.5rem;
  background-color: #b8e9d6;
  border-radius: 5px;
  font-style: italic;
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Maps/RegistrationMap/RegistrationMap.vue